import * as React from "react";
import LinearProgress from '@material-ui/core/LinearProgress';
import {Box, Typography, Button, ListItem} from '@material-ui/core';
import {useState} from "react";
import axios from "axios";
import {SERVER_URL} from "../../utils";
import Grid from "@material-ui/core/Grid";

export const ImportCsv = (props) => {
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState("");

    return (
        <div className="mg20">
            <Grid container style={{marginTop: "4%", display: "flex", justifyContent: "center"}}>
                <label htmlFor="btn-upload">
                    <input
                        id="btn-upload"
                        name="btn-upload"
                        style={{display: 'none'}}
                        type="file"
                        accept=".xlsx"
                        onChange={(event) => {
                            setFile(event.target.files[0]);
                            console.log(event.target.files)
                        }}/>
                    <Button
                        className="btn-choose"
                        variant="outlined"
                        component="span">
                        Seleziona file
                    </Button>
                </label>
                <div className="file-name">
                    {file && file.length > 0 ? file.name : null}
                </div>
                <Button
                    className="btn-upload"
                    color="primary"
                    variant="contained"
                    component="span"
                    disabled={!file}
                    style={{
                        marginLeft: "2%"
                    }}
                    onClick={async () => {
                        const formData = new FormData();
                        formData.append("file", file);
                        setStatus("Importazione in corso");
                        const res = await axios.post(SERVER_URL + "/api/v1/utils/upload-csv-file", formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            withCredentials: true
                        })
                        setStatus(res.data);
                    }}>
                    Upload
                </Button>
            </Grid>
            <Typography variant="h6" className="list-header">
                File selezionato
            </Typography>
            <ul className="list-group">
                {file &&
                    <ListItem
                        divider>
                        <a href={file.url}>{file.name}</a>
                    </ListItem>
                }
            </ul>
            <Box>
                {status && (
                    <div>
                        {status === "Importazione eseguita correttamente!" && <p style={{
                            color: "green"
                        }}>{status}</p>}
                        {status === "Importazione in corso" && <div>
                            {status}
                            <LinearProgress/>
                        </div>}
                        {status !== "Importazione in corso" && status !== "Importazione eseguita correttamente!" &&
                            <p style={{
                                color: "red"
                            }}>{status}</p>}
                    </div>
                )}
            </Box>
        </div>
    );
}
